export enum OwnerType {
  SITE = 'site',
  COMPANY = 'company',
  MARKET = 'market',
  FISH_GROUP = 'fishgroup',
}
